// dependencies
import { useState } from "react";

// components
import { ArrowSVG } from "../../ui/SVGs";

// styles
import styles from "./css/ExperienceCard.module.css";



export default function ExperienceCard({ workName, workTitle, developmentPeriod, expText, linkToProject }) {
    const [showExpText, setShowExpText] = useState(false)

    return (
        <div className={styles.experienceCardContainer}>
            {/* clickable header */}
            <button 
                className={styles.header} 
                onClick={() => setShowExpText(prev => !prev)}
                aria-expanded={showExpText}
            >
                <div className={styles.headerInfo}>
                    <div className={styles.workName}>
                        {workName} 
                        <span className={`${styles.arrow} ${showExpText ? styles.rotated : ''}`}>
                            <ArrowSVG />
                        </span>
                    </div>
                    <div className={styles.workTitle}>{workTitle}</div>
                </div>
                <div className={styles.experiencePeriod}>{developmentPeriod}</div>
            </button>

            {/* text */}
            <div className={`${styles.expText} ${showExpText ? styles.show : ''}`}>
                <div className={styles.expTextContent}>{expText}</div>
                {
                    linkToProject && 
                    <a className={styles.linkToProject} href={linkToProject} target="_blank" rel="noopener noreferrer">
                        {workName} - Project
                    </a>
                }
            </div>
        </div>
    );
}
